import { render, staticRenderFns } from "./MaterialValidationSettingsComponent.vue?vue&type=template&id=67c90230"
import script from "./MaterialValidationSettingsComponent.vue?vue&type=script&lang=ts"
export * from "./MaterialValidationSettingsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports